// This file was auto-generated by Fern from our API Definition.
/** How usable the stored subscription login is right now. */
export const SubscriptionLoginState = {
    PendingLogin: "pending_login",
    Ready: "ready",
    NeedsLogin: "needs_login",
};
